<template>
<div id="contents">
  <div id="tapcast" class="page_contents">

    <div id="tapcast_contents">
      <div id="tapcast_show" v-if="tapcast" class="page_main_contents">

        <div id="tapcast_show_main" class="page_main_contents">
          <p id="tapcast_show_main_image"><img :src="tapcast.single_main_image" width="" alt="クリエイター写真" ></p>
          <div id="tapcast_show_main_name">
            <p class="category">{{ tapcast.short_introduce }}</p>
            <h1>{{ tapcast.name }}</h1>
            <p class="name_en">{{ tapcast.english_name }}</p>
          </div><!-- #tapcast_show_main_name -->

          <p class="page_close hover"><router-link v-bind:to="{name: 'tapcast_index'}"><img src="../assets/img/common/page/close_icon.png" width="55" alt="閉じるボタン" ></router-link></p>
        </div><!-- #players_show_main -->

        <div id="tapcast_show_body" class="page_main_contents">
          <div id="tapcast_show_body_contents">
            <p v-html="tapcast.content"></p>
          </div><!-- #tapcast_show_contents -->

          <div id="tap_cast_link">
            <div class="link_box" v-if="tapcast.home_url">
              <h3>公式HP</h3>
              <p><a :href="tapcast.home_url" target="_blank">{{ tapcast.home_url }}</a></p>
            </div><!-- .link_box -->

            <div class="link_box" v-if="tapcast.blog_url">
              <h3>公式ブログ</h3>
              <p><a :href="tapcast.blog_url" target="_blank">{{ tapcast.blog_url }}</a></p>
            </div><!-- .link_box -->

            <div class="link_box" v-if="tapcast.instagram_url">
              <h3>Instagram</h3>
              <p><a :href="tapcast.instagram_url" target="_blank">{{ tapcast.instagram_url }}</a></p>
            </div><!-- .link_box -->

            <div class="link_box" v-if="tapcast.twitter_url">
              <h3>Twitter</h3>
              <p><a :href="tapcast.twitter_url" target="_blank">{{ tapcast.twitter_url }}</a></p>
            </div><!-- .link_box -->

            <div class="link_box" v-if="tapcast.facebook_url">
              <h3>Facebook</h3>
              <p><a :href="tapcast.facebook_url" target="_blank">{{ tapcast.facebook_url }}</a></p>
            </div><!-- .link_box -->
          </div><!-- #tap_cast_link -->
        </div><!-- #tapcast_show_body -->

        <ul id="page_nav" v-if="tapcast">
          <p class="hover" v-if="tapcast.next_post_id"><router-link v-bind:to="{name: 'tapcast_show', params: {id: tapcast.next_post_id}}"><img src="../assets/img/common/page/arrow.png" width="20" alt="右矢印" ></router-link></p>
          <p v-else></p>

          <p class="hover" v-if="tapcast.prev_post_id"><router-link v-bind:to="{name: 'tapcast_show', params: {id: tapcast.prev_post_id}}"><img src="../assets/img/common/page/arrow.png" width="20" alt="右矢印" ></router-link></p>
          <p v-else></p>
        </ul><!-- #page_nav -->

      </div><!-- #tapcast_show -->
    </div><!-- #tapcast_contents -->



  </div><!-- #tapcast -->

</div><!-- #contents -->
</template>

<script>
export default {
  name: 'tapcast_show',
  data() {
    return {
      api_url: this.$parent.api_base_url+'/api/tapcast/show.php',
      loading: true,
      tapcast: null,
      error: null
    }
  },
  methods: {
    fetch_tapcast(){
      this.$axios
        .get(this.api_url ,{
          params: {
            id: this.$route.params.id
          }
        })
        .then(response => {
          this.tapcast = response.data.item[0]
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally()
    }
  },
  watch: {
    '$route' (to, from) {
      this.fetch_tapcast()
    }
  },
  mounted () {
    this.fetch_tapcast()
  },
  updated (){
    var queue = new createjs.LoadQueue(true);
    const ts = this;
    queue.loadManifest([this.tapcast.single_main_image],true);
    queue.addEventListener("complete",function(){
      ts.$emit('page_fade')
    });
  }
}
</script>

<style scoped lang="sass">
</style>



// WEBPACK FOOTER //
// src/components/tapcast_show.vue